var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698e7a3e503f0627532b181b0b5e941e.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dcda177c2c3722ccefa8c3609e4cd004.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eb3ca9c87d63c99a72b6dc292ec6d31a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    